// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout_wrapper__TQijR","errorPage":"Layout_errorPage__dSY7G"};